const setVerticalSettings = (
  vertical: boolean,
): { width: number; height: number } => {
  if (vertical) {
    return {
      width: 340,
      height: 477.01,
    };
  }

  return {
    width: 340,
    height: 187.31,
  };
};

export { setVerticalSettings };
